module.exports = __webpack_public_path__ + "img/documents.9c7f10f0.png";